import { TicketsService } from "@/services";
import dayjs from "dayjs";

export default {
  name: "dashboard-tickets-card",
  components: {},
  props: [],
  data() {
    return {
      tickets: null,
      dashboardTicketLoader: true
    };
  },
  filters: {
    fromNowDate(date) {
      return dayjs(date).format("YYYY/MM/DD hh:mm");
    }
  },
  computed: {},
  mounted() {
    this.getOrdersData();
  },
  methods: {
    getOrdersData() {
      TicketsService.getTickets({
        page: 1
      })
        .then(response => {
          this.tickets = response.data.data;
        })
        .finally(() => {
          this.dashboardTicketLoader = false;
        });
    },
    redirectToTicket(ticket) {
      this.$router.push({ path: `/tickets/${ticket.id}` });
    }
  }
};
